<template>
  <div>
    <div>
      <span class="xbed-sub-title">活动奖励管理</span>
    </div>
    <div class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>营销管理</BreadcrumbItem>
        <BreadcrumbItem>活动奖励管理</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <br>
    <Form @submit.native.prevent="preventSubmit" inline>
      <FormItem label='奖励名称' :label-width='80'>
        <Input type='text' v-model.trim="searchParams.activityRewardName" style="width:200px;"></Input>
      </FormItem>
      <FormItem label='奖励类型' :label-width='80'>
        <Select ref="resetCity" v-model="searchParams.type" filterable>
          <Option value="-1">全部</Option>
          <Option v-for="(item, index) in allrewards" :value="item.type" :key="index">{{ item.name }}</Option>
        </Select>
      </FormItem>
      <FormItem label='关联活动' prop='activityName' :label-width='80'>
        <Input type='text' v-model="searchParams.activityName" style="width:200px;"></Input>
      </FormItem>
      <br/>
      <FormItem :label-width="10">
        <Button type="primary" @click="changeQueryKeyWord">查询</Button>
      </FormItem>
      <FormItem :label-width="10">
        <Button type="primary" @click="handleRewardDetail()">新增奖励</Button>
      </FormItem>
      <FormItem :label-width="10">
        <Button type="primary" @click="handleManualRewardFn()">手动赠送</Button>
      </FormItem>
      <Content>
        <Table stripe :columns="columnsList" :data='dataList' :loading='cardListLoading'></Table>
        <div style="margin: 10px;overflow: hidden">
          <Page show-sizer show-total :page-size="searchParams.size" :current="searchParams.page" :total="listTotal" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
        </div>
      </Content>
    </Form>
  </div>
</template>

<script>
/* eslint-disable */
import API from "@/api";
import Utils from "../../utils";
export default {
  created () {
    this.token = Utils.findFromLocalStorage( "vue-token" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
		this.userId = Utils.findFromLocalStorage( "vue-userid" );
    this.env = Utils.findFromLocalStorage( "env", "dev" );

    // 阿里云接口，header 传参（只有开发环境和测试环境需要传 group）
    this.protHeaders = {
      'x-ca-stage': Utils.aliHeaderEnv(this.env), 
      'Authorization': Utils.findFromLocalStorage("Author-token"),
      // 'secret': '58dbac0cb9a1db115a473199f8d312e6', // 本地请求 IP 域名才需要传 secret
    }
    if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'testing') {
      this.protHeaders.group = process.env.NODE_ENV === 'development' ? 'dev' : 'qa'
    }
  },
  data () {
    return {
      cardListLoading:false,
      dataList:[],
      listTotal:0,
      columnsList:[
        {
          title:'ID',
          key:'rewardId',
          align:'center',
          width:100
        },
        {
          title:'奖励名称',
          key:'name',
          align:'center',
          width:300
        },
        {
          title:'奖励类型',
          key:'type',
          align:'center',
          width:250,
          render: (h, params) => {
            let _type = ['', '预订金额折扣', '预订金额减免', '赠送优惠券', '', '预订房晚兑换'][params.row.type]
            return h('span', {}, _type)
          }
        },
        {
          title:'奖励内容',
          key:'rewardId',
          align:'center',
          width:332,
          render: (h, params) => {
            let text = `原价满${params.row.originalPrice / 100}元 `
            switch (params.row.type) {
              case 1:
                text += `享${params.row.discount / 10}折 最高减${params.row.maxDiscountPrice / 100}元`
                break;
              case 2:
                text += `减${params.row.discountPrice / 100}元`
                break;
              case 3:
                text = `赠送优惠券${params.row.bindCardNumber}张`
                break;
              case 5:
                text += `减房费${params.row.roomNight}晚 最高减${params.row.maxDiscountPrice / 100}元`
                break;
              default:
                break;
            }
            return h('span', {}, text)
          }
        },
        {
          title:'关联活动数',
          key:'activityBindNumber',
          align:'center',
          width:130,
          render: (h, params) => {
            let num = params.row.activityBindNumber ? params.row.activityBindNumber : '0'
            return h('span', {}, num )
          }
        },
        {
          title:'操作',
          key:'id',
          align:'center',
          width:200,
          render:(h,params) => {
            return h('div',
            [
              h('Button',{
                props:{
                  type:'info',
                  size:'small'
                },
                style:{
                  marginRight:'5px'
                },
                on:{
                  click:()=>{
                    this.handleRewardDetail(params.row.rewardId)
                  }
                }
              },'详情'),
              h('Button',{
                props:{
                  type:'error',
                  size:'small'
                },
                on:{
                  click:()=>{
                    if ( !Utils.hasPermission( 'acticityReward_del' ) ) {
                      this.$Notice.error( {
                        title: "无权限操作"
                      } );
                      return
                    }
                    if (params.row.activityBindNumber > 0) {
                      this.$Notice.error( {
                        title: "奖励删除失败，请取消活动关联后再试"
                      } ); 
                      return
                    }
                    this.$Modal.confirm({
                      title:'消息提醒',
                      content: `确定删除<span style='color:red;'>${params.row.name}</span>吗？一经确定将无法修改`,
                      okText:'确定',
                      cancelText:'取消',
                      onOk:()=>{
                        this.deleteBtn(params.row.rewardId)
                      }
                    })
                  }
                }
              },'删除')
            ])
          }
        },
      ],

      // 活动奖励优化 - 20200121
      searchParams: {
        page: 1,
        size: 10,
        activityRewardName: '',
        type: '-1',
        activityName: ''
      },
      allrewards: [ // 所有奖励类型
        {
          name: '赠送优惠券',
          type: 3,
        },
        {
          name: '预订金额减免',
          type: 2,
        },
        {
          name: '预订金额折扣',
          type: 1,
        },
        {
          name: '预订房晚兑换',
          type: 5,
        },
      ],
    }
  },
  mounted () {
    this.$Notice.config( {
			top: 200
    });
    this.queryList()
  },
  methods: {
    // 列表页信息
    async queryList(){
      if ( !Utils.hasPermission( 'acticityReward_list' ) ) {
				this.$Notice.error( {
					title: "无权限操作"
				} );
				return
      }
      this.cardListLoading = true

      let param = this.searchParams
      // 过滤空字段
      param = Object.keys(param).reduce(function(c, k) {
        if (param[k] && param[k] != '-1') {
          c[k] = param[k]
        }
        return c
      }, {})

      try {
        let resp = (await API.omsAPI[this.env].clientServer.getActivityReward(param, this.protHeaders)).data;
        this.cardListLoading = false
        if (resp.retCode) {
          this.$Notice.error({
            title: '获取活动奖励列表数据异常',
            desc: resp.msg
          })
          return
        }
        this.dataList = resp.content
        this.listTotal = resp.total

      } catch(e) {
        this.cardListLoading = false
        this.$Notice.error({
          title: '服务器异常，请稍后再试'
        })
      }
    },
    changeQueryKeyWord(){
      this.searchParams.page = 1
      this.queryList()
    },
    changePageSize(pageSize){
      this.searchParams.page = 1
      this.searchParams.size = pageSize
      this.queryList()
    },
    changePage(page){
      this.searchParams.page = page
      this.queryList()
    },

    // 删除
    async deleteBtn(rewardId){
      let params = {
        rewardId,
        userId: this.userId
      }
      let resp = (await API.omsAPI[this.env].clientServer.deleteActivityReward(params, this.protHeaders)).data;
      if (resp.retCode) {
				this.$Notice.error({
					title: '删除失败',
					desc: resp.msg
        })
        this.$refs.activitiesRewardModal.buttonLoading = false;
				return
      }
      this.$Notice.success({
        title: '删除成功',
        desc: resp.msg
      })
      this.queryList()
    },

    // 活动奖励优化 - 20200121
    handleRewardDetail(rewardId) {
      if ( !Utils.hasPermission( 'acticityReward_content_list' ) ) {
        this.$Notice.error( {
          title: "无权限操作"
        } );
        return
      }
      let _url = this.$router ? '#/app/marketing/activityRewardContentList' : '#/Market/Market/activityRewardContentList'
      if (rewardId) {
        _url = `${_url}?id=${rewardId}`
      }
      window.open(_url)
    },

    // 手动赠送
    handleManualRewardFn() {
      if (!Utils.hasPermission('app_marketing_activityManualReward')) {
				this.$Notice.error( {
					title: "没有查看手动赠送权限"
				} );
				return
      }
      let _url = this.$router ? '#/app/marketing/activityManualReward' : '#/Market/Market/activityManualReward'
      window.open(_url)
    }
  },
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/pages/marketing/activityRewardList.vue